import Alpine from 'alpinejs';
import { Availibilities, Availibility, AvailibilitySlot, MeetMethod, StoredShopData } from './types';
import { getUserData } from '../../helpers/user'
import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
// import {SimpleCheckChoice} from "../../scripts/forms/quotation-form/types";

interface BookingFormAlpine extends AlpineComponentTryba {
    storedShopData: StoredShopData;
    shopCode: string | null;
    meetMethod: MeetMethod | null;
    currentDate: Date;
    currentPage: number;
    formattedDate: string | null;
    formattedDateRecap: string | null;
    meetHoursUrl: string;
    availabilities: Availibilities | null;
    limit: number;
    loadingMeethours: boolean;
}

let storeLocalAvailabilities;
let storeLocalShopCode;

document.addEventListener('alpine:init', () => {
    Alpine.data('initBookingForm', (fromAbTest): BookingFormAlpine => {
        return {
            isFromAbTest: fromAbTest == 'fromAbTest' ? true : false,
            storedShopData: [],
            shopCode: null,
            meetMethod: null,
            currentDate: new Date(),
            currentPage: 1,
            formattedDate: null,
            formattedDateRecap: null,
            meetHoursUrl: '/api/espace-conseil/disponibilites/',
            shopPhone: '03 88 43 00 20',
            availabilities: null,
            limit: 3,
            loadingMeethours: false,
            displayPrevArrow: false,
            slotStep: 0,
            localAvailabilities: null,
            city: null,
            // AbTest
            abPrettySlot: null,
            abSlot: null,
            init(): void {
                if (window.localStorage.getItem('ab-quick-meethours-prettySlot') && window.localStorage.getItem('ab-quick-meethours-slot') && (/demande-de-rendez-vous/.test(window.location.href))) {
                    this.abPrettySlot = window.localStorage.getItem('ab-quick-meethours-prettySlot')
                    this.abSlot = window.localStorage.getItem('ab-quick-meethours-slot')

                    this.dataChoice[this.step.name] = this.abSlot
                    this.arrayChoice[this.step.name] = this.abPrettySlot

                    setTimeout(() => {
                        this.prevSteps.push(this.step);
                        this.nextStepKey = this.step.fieldsNextStep;
                        this.nextStep();

                        window.localStorage.removeItem('ab-quick-meethours')
                        window.localStorage.removeItem('ab-quick-meethours-prettySlot')
                        window.localStorage.removeItem('ab-quick-meethours-slot')
                    }, 500);
                } else {
                    if (this.isFromAbTest) {
                        // Bg color of section
                        document.querySelector('.express_appointment_form')?.querySelector('.left-0')?.classList.add('!h-full');
                        this.loadingMeethours = true;
                        this.dateFormation();
                        const userData = getUserData();
                        if (userData && userData.shop) {
                            this.shopCodeState = userData.shop.clientNumber;
                            if (userData.shop.city) {
                                this.city = userData.shop.city;
                            }
                            if (userData.shop.phone) {
                                this.shopPhoneState = userData.shop.phone;
                            }
                        }
                        this.getAvailabilities();
                    } else {
                        if (this.step.name == 'availability') {
                            this.loadingMeethours = true;
                            //Formatted current Date
                            this.dateFormation();
                            //Get reservation type
                            if (this.arrayChoice[1] == 'À domicile') {
                                this.meetMethod = 'home';
                            }
                            const userData = getUserData();
                            if (userData && userData.shop) {
                                this.shopCodeState = userData.shop.clientNumber;
                                if (userData.shop.phone) {
                                    let good_format = userData?.shop?.phone ? userData.shop.phone : this.shopPhone;
                                    if (userData?.shop?.phone) {
                                        good_format = "0" + userData?.shop?.phone.slice(4);
                                    }
                                    good_format = good_format.match(/.{1,2}/g).join(" ");

                                    this.shopPhoneState = good_format;
                                } else {
                                    this.shopPhoneState = this.shopPhone;
                                }
                            }
                            this.getAvailabilities();
                        } else {
                            this.prevSteps.forEach((item) => {
                                if (item.name == 'availability') {
                                    this.availabilities = storeLocalAvailabilities
                                }
                            })
                        }
                    }
                }
            },
            async getAvailabilities(): Promise<void> {
                this.loadingMeethours = true;
                if (!this.$store.global.isMobile) {
                    if (this.isFromAbTest) {
                        this.limit = 7;
                    } else {
                        this.limit = 5;
                    }
                }
                //Api call to get store availabilities about meetethod, date and store selected
                const newUrl = `${this.meetHoursUrl}${this.shopCode}/?start=${this.formattedDate}&meetMethod=${this.meetMethod}&limit=${this.limit}&page=${this.currentPage}`;
                const response = await fetch(newUrl);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data = await response.json();
                this.loadingMeethours = false;
                this.availabilities = data;
                storeLocalAvailabilities = data
                storeLocalShopCode = this.shopCode

                if (this.choice) {
                    this.hasChoice();
                }
            },
            async getShopPhone(): Promise<void> {
                const response = await fetch(`/api/espace-conseil/phone/${this.shopCode}`);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                this.shopPhone = await response.text();
            },
            hasChoice(): void {
                Object.entries(this.availabilities as Availibilities).forEach((availibility: [string, Availibility]) => {
                    Object.entries(availibility[1].slots).forEach((slot: [string, AvailibilitySlot]) => {
                        if (this.choice.from && this.choice.from.date === slot[1].from.date || !this.choice.from && this.choice.value === slot[1].value) {
                            slot[1].active = true;
                        }
                    });
                });
            },
            handleClickSlotPrevStep(slot: AvailibilitySlot, item: AvailibilitySlot) {
                this.prevSteps.forEach((item) => {
                    if (item.name == 'availability') {
                        this.step = item
                    }
                })
                //Reset slots
                Object.entries(this.availabilities as Availibilities).forEach((availibility: [string, Availibility]) => {
                    Object.entries(availibility[1].slots).forEach((slot: [string, AvailibilitySlot]) => {
                        if (this.choice.from && this.choice.from.date === slot[1].from.date || !this.choice.from && this.choice.value === slot[1].value) {
                            slot[1].active = false;
                        }
                    });
                });
                //Set loading true
                this.loading = true;
                //Delete slot already selected
                if (this.arrayChoice[2]) {
                    this.arrayChoice.pop();
                }
                //Get stepChoice object
                this.choice = slot;
                //Format for recap
                if (this.choice.from) {
                    const date = new Date(this.choice.from.date);
                    const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
                    const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
                    const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
                    const dataHourRecap = date.getHours().toString().padStart(2, '0');
                    const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
                    this.formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
                    //Prepare form data
                    this.dataChoice[this.step.name] = this.choice.from.date;
                } else {
                    const dataDayRecap = item.date
                    const dataMonthRecap = item.month
                    this.formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} - ` + this.choice.prettySlot
                    //Prepare form data
                    this.dataChoice[this.step.name] = this.choice.value;
                }
                //Make choice as active
                this.choice.active = true;
                //Push in array the choice
                this.arrayChoice[this.step.name] = this.formattedDateRecap;
                //Prepare form data
                // this.dataChoice[this.step.name] = this.choice.from.date;
                //Get next step key
                this.nextStepKey = this.step.fieldsNextStep;
                //Delete in prevSteps, arrayChoice and dataChoice all infos after actual step
                const targetName = this.step.name;
                const targetIndex = this.prevSteps.findIndex((obj) => obj.name === targetName);
                if (targetIndex !== -1) {
                    this.prevSteps.splice(targetIndex + 1);
                }
                let foundArrayChoice = false;
                for (const key in this.arrayChoice) {
                    if (foundArrayChoice) {
                        delete this.arrayChoice[key];
                    }
                    if (key === targetName) {
                        foundArrayChoice = true;
                    }
                }

                let foundDataChoice = false;
                for (const key in this.dataChoice) {
                    if (foundDataChoice) {
                        delete this.dataChoice[key];
                    }
                    if (key === targetName) {
                        foundDataChoice = true;
                    }
                }
                //Go next step
                setTimeout(() => {
                    this.nextStep(targetIndex + 1);
                }, 200);
            },
            handleClickSlot(slot: AvailibilitySlot, item: AvailibilitySlot) {
                //Reset slots
                Object.entries(this.availabilities as Availibilities).forEach((availibility: [string, Availibility]) => {
                    Object.entries(availibility[1].slots).forEach((slot: [string, AvailibilitySlot]) => {
                        if (this.choice) {
                            slot[1].active = false;
                        }
                    });
                });
                if (this.isFromAbTest) {
                    //Get stepChoice object
                    this.choice = slot;
                    //Format for recap
                    if (this.choice.from) {
                        const date = new Date(this.choice.from.date);
                        const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
                        const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
                        const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
                        const dataHourRecap = date.getHours().toString().padStart(2, '0');
                        const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
                        this.formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
                        //Prepare form data
                        // this.dataChoice[this.step.name] = this.choice.from.date;
                    } else {
                        const dataDayRecap = item.date
                        const dataMonthRecap = item.month
                        const dataYearRecap = item.year
                        this.formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ` + this.choice.prettySlot
                        //Prepare form data
                        // this.dataChoice[this.step.name] = this.choice.value;
                    }
                    window.localStorage.setItem('ab-quick-meethours-prettySlot', this.formattedDateRecap);
                    window.localStorage.setItem('ab-quick-meethours-slot', this.choice.value);
                    window.location.href = `/demande-de-rendez-vous/?depuis-express#etape2`;
                } else {
                    if (this.step.type == 'availability') {
                        //Set loading true
                        this.loading = true;
                        //Delete slot already selected
                        if (this.arrayChoice[2]) {
                            this.arrayChoice.pop();
                        }
                        //Get stepChoice object
                        this.choice = slot;
                        //Format for recap
                        if (this.choice.from) {
                            const date = new Date(this.choice.from.date);
                            const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
                            const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
                            const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
                            const dataHourRecap = date.getHours().toString().padStart(2, '0');
                            const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
                            this.formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
                            //Prepare form data
                            this.dataChoice[this.step.name] = this.choice.from.date;
                        } else {
                            const dataDayRecap = item.date
                            const dataMonthRecap = item.month
                            const dataYearRecap = item.year
                            this.formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ` + this.choice.prettySlot
                            //Prepare form data
                            this.dataChoice[this.step.name] = this.choice.value;
                        }
                        //Make choice as active
                        this.choice.active = true;
                        //Push in array the choice
                        this.arrayChoice[this.step.name] = this.formattedDateRecap;
                        //Prepare form data
                        // this.dataChoice[this.step.name] = this.choice.from.date;
                        //Get next step key
                        this.nextStepKey = this.step.fieldsNextStep;
                        //Go next step
                        setTimeout(() => {
                            this.prevSteps.push(this.step);
                            this.nextStep();
                        }, 200);
                    } else {
                        this.step = this.steps['availability']
                        //Delete all infos after this step
                        const targetName = this.step.name;
                        const targetIndex = this.prevSteps.findIndex(obj => obj.name === targetName);
                        this.prevSteps.splice(targetIndex);

                        let foundArrayChoice = false;
                        for (const key in this.arrayChoice) {
                            if (foundArrayChoice) {
                                delete this.arrayChoice[key];
                            }
                            if (key === targetName) {
                                foundArrayChoice = true;
                            }
                        }

                        let foundDataChoice = false;
                        for (const key in this.dataChoice) {
                            if (foundDataChoice) {
                                delete this.dataChoice[key];
                            }
                            if (key === targetName) {
                                foundDataChoice = true;
                            }
                        }
                        //Active the field
                        this.displayChoices = false
                        this.displayFields = true
                        //Get stepChoice object
                        this.choice = slot;
                        //Format for recap
                        const date = new Date(this.choice.from.date);
                        const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
                        const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
                        const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
                        const dataHourRecap = date.getHours().toString().padStart(2, '0');
                        const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
                        this.formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
                        //Make choice as active
                        this.choice.active = true;
                        //Push in array the choice
                        this.arrayChoice[this.step.name] = this.formattedDateRecap;
                        //Prepare form data
                        this.dataChoice[this.step.name] = this.choice.from.date;
                        //Get next step key
                        this.nextStepKey = this.step.fieldsNextStep;
                        //Go next step
                        setTimeout(() => {
                            this.prevSteps.push(this.step);
                            this.nextStep();
                        }, 200);
                    }
                }
            },
            dateFormation() {
                const dataYear = this.currentDate.toLocaleString('default', { year: 'numeric' });
                const dataMonth = this.currentDate.toLocaleString('default', { month: '2-digit' });
                const dataDay = this.currentDate.toLocaleString('default', { day: '2-digit' });
                this.formattedDate = `${dataYear}-${dataMonth}-${dataDay}`;
            },
            nextAvailabilities() {
                this.slotStep = this.slotStep + 1
                if (!this.shopCode) {
                    this.shopCode = storeLocalShopCode
                }
                // Add seven days to currentDate
                this.currentDate.setDate(this.currentDate.getDate() + this.limit);
                // Add a page to currentPage
                this.currentPage = this.currentPage + 1
                // Formatted current Date
                this.dateFormation();
                this.getAvailabilities();
            },
            previousAvailabilities() {
                this.slotStep = this.slotStep - 1
                if (!this.shopCode) {
                    this.shopCode = storeLocalShopCode
                }
                // Remove seven days from currentDate
                this.currentDate.setDate(this.currentDate.getDate() - this.limit);
                // Remove a page from currentPage
                this.currentPage = this.currentPage - 1
                // Formatted current Date
                this.dateFormation();
                this.getAvailabilities();
            },
        };
    });
});
